<template>
    <div class="row child-component">

        <div class="col-lg-7 col-md-8 col-sm-8 col-xs-6 mx-auto" style="
    background-color: #e7efeed6;
">

            <div class="d-block row col-lg-8  mx-auto well">
                <div class="fieldborder text-right" style="margin-top: 15px;">
                    <button type="button" class="btn btn-primary btn-md" style="margin-left:60px;"
                        @click="downloadUploadTemplate();">Download Template </button>
                </div>
                <div class="fieldborder" style="margin-top: -4px">
                    <label for="axlocatoin" class="lbltxt">ATTACH THE OMNICOM EXTERNAL VENDOR FORM COMPLETED BY THE
                        VENDOR</label>

                    <vue-dropzone v-on:vdropzone-mounted="mountedmyVueDropzone" :duplicateCheck="true" ref="myVueDropzone"
                        id="dropzone" :useCustomSlot="true" class="customdropzone" :include-styling="false"
                        :options="dropzoneOptions" v-on:vdropzone-file-added="UploadedToDropzone"
                        v-on:vdropzone-removed-file="RemovedFromDropzone">
                        <div class="dropzone-custom-content">
                            <p class="Drag-and-drop-file-h">
                                <b-img style="
                        margin-top: -7px !important;
                        font-family: 'Open Sans';
                      " />
                                Drag and drop template here or
                                <span class="draganddropspan"> browse </span>

                            </p>
                        </div>
                    </vue-dropzone>
                    <div class="note-section mt-2">
                        <p>Acceptable file type: {{ AllowedFileUploadTypes }}.</p>
                    </div>
                </div>
                <div class="note-section mt-n2">
                    <label>Note <span style="color:red">*</span></label>
                    <p>If you have not received the Completed Omnicom External Vendor Form, you will not be able to continue. Please click the Download Template button to retrieve form, have the vendor complete the form, and then you may start this vendor request.</p>
                </div>
                <br>
                <br>
                <br>
                <br>
            </div>
        </div>
        <div class="form-group pt-60 text-right  footer-buttons" style="padding-right:96px !important;">
            <button class="btn btn-link text-uppercase" @click="Cancel()">
                CANCEL
            </button>
            <button v-if="IsDraftVisible" class="text-uppercase btn btn-secondary btn-primary" @click="SaveAsDraft()">
                SAVE FOR LATER
            </button>
            <button class="text-uppercase btn custom-button btn-primary" @click="Previous()">
                BACK
            </button>
            <button class="text-uppercase btn custom-button btn-primary" @click="Next()" :disabled="this.$v.$invalid">
                NEXT
            </button>
        </div>
    </div>
</template>

<style scoped>
.customdropzone {
    height: auto !important;
    border-radius: 8px !important;
    border: dashed 2px #e9eef0 !important;
    background-color: #ffffff !important;
    cursor: pointer !important;
}

.Drag-and-drop-file-h {
    margin-left: 18px !important;
    margin-top: 14px !important;
    width: 387px !important;
    height: 10px !important;
    font-family: "Open Sans" !important;
    font-size: 14px !important;
    font-weight: normal !important;
    font-stretch: normal !important;
    font-style: normal !important;
    line-height: 0.71 !important;
    letter-spacing: normal !important;
    /* color: #a2a9ad !important; */
}


.zipcodevalidationmsg {
    /* margin-top: -20px !important; */
    width: 157px !important;
    font-size: 10px !important;
    color: #df5678 !important;
    font-family: "Open Sans" !important;
    font-size: 11px !important;
    font-weight: normal !important;
    font-stretch: normal !important;
    font-style: italic !important;
    line-height: 0.8 !important;
    letter-spacing: normal !important;
    text-align: left !important;
}

.error-message1 {
    height: 14px !important;
    font-size: 10px !important;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #df5678 !important;
}


.draganddropspan {
    color: #00a1d2;
}

.error-message {
    padding-top: 10px;
    padding-bottom: 5px;
    height: 14px !important;
    font-size: 12px !important;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #df5678 !important;
}

.floating-label-input {
    margin-top: 0px !important;
}

.fieldborder {
    padding-bottom: 30px !important;
}

.omniipclass {
    /* width: 415px !important; */
    height: 35px !important;
    border: #e9eef0 !important;
    /* style="width:415px; height:35px;" */
}

.Text {
    width: 250px;
    height: 196px;
    font-family: "Open Sans";
    font-size: 10px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #ffffff;
}

.Text .text-style-1 {
    font-weight: 600;
}
</style>

<script>
import {
    mapGetters
} from "vuex";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import store from "@/store";
import * as AllowedFileUploadExtensions from "../../../utilities/AllowedFileUploadExtensions";
import {
    required,
    minLength
} from "vuelidate/lib/validators";
import productionVendorSaveAsDraft from '../../../mixins/productionVendorSaveAsDraft.js';
export default {
    mixins: [productionVendorSaveAsDraft],
    props: {
        id: {
            type: Number,
            required: false,
        },
        isDraft: {
            type: Boolean,
            required: false
        }
    },
    activated() {
        this.$parent.$emit("stepInitiated", this.$route.meta.tabIndex);
    },
    data() {
        return {
            deleteIcon: require("@/assets/Icons/delete.svg"),
            closeFilterIcon: require("../../../assets/Icons/file.png"),
            FilesUploaded: false,
            AllowedFileUploadTypes: AllowedFileUploadExtensions.ExternalVendorFormsExtensions.join(", "),
            dropzoneOptions: {
                paramName: "file",
                //params: {'param_1':'xyz','para_2': localid },
                previewTemplate: this.template(),
                url: `${process.env.VUE_APP_API_ROOT}api/v1/mdm/Upload`,
                uploadMultiple: true,
                maxFiles: 5,
                minFiles: 1,
                maxFilesize: 10,
                addRemoveLinks: false,
                parallelUploads: 5,
                createImageThumbnails: false,
                autoProcessQueue: false,
                init: function () {
                    this.on("addedfile", function (file) {
                        if (this.files.length > 5) {
                            this.removeFile(file);
                            window.alert("Maximum File Upload limit is 5!");
                        }
                    });

                    this.on("removedfile", function () { });
                },
                accept: function(file, done) {
                    let fileExtension = file.name.split('.').pop().toLowerCase();
                    if (!AllowedFileUploadExtensions.ExternalVendorFormsExtensions.includes(fileExtension)) {
                        store.dispatch(
                            "progress/setErrorMessage",
                            `Unsupported file type. Please upload a valid file type.`
                        );
                        this.removeFile(file);
                    } else {
                    done();
                    }
                },
            },
        }
    },
    validations: {
        ProdExpVendor: {
            CompletedForms: {
                minLength: minLength(1),
                required
            }
        }
    },
    components: {
        vueDropzone: vue2Dropzone
    },
    computed: {
        IsEdit() {
            return this.id && !isNaN(this.id) && parseInt(this.id) > 0 ? true : false;
        },
        ...mapGetters('prodexpvendor', {
            ProdExpVendor: 'ProdExpVendor',
        }),
        IsDraftVisible: function() {
            return this.id == null || this.id == 0 || this.isDraft == true;
        }
    },
    watch: {
        "ProdExpVendor.IsEditDataLoaded": function (val) {
            if (this.IsEdit == true && val == true) {
                this.ManuallyUploadFiles(this.ProdExpVendor.CompletedForms);
            }
        },
    },
    mounted() {
        if (this.IsEdit == true && this.ProdExpVendor.IsEditDataLoaded == true) {
            this.ManuallyUploadFiles(this.ProdExpVendor.CompletedForms);
        }
    },
    methods: {
        mountedmyVueDropzone() {
            if ((this.ProdExpVendor.ID > 0 && this.FilesUploaded == false) || this.isDraft === true) {
                this.ManuallyUploadFiles(this.ProdExpVendor.CompletedForms);
                this.$set(this.ProdExpVendor, "CompletedForms", this.GetFilesObject());
            }
        },
        ManuallyUploadFiles(files) {
            if (this.$refs.myVueDropzone != null) {
                if (files != null && files.length > 0 && this.FilesUploaded == false) {
                    files.forEach((fileUploaded) => {
                        let file = {
                            size: fileUploaded.Length,
                            name: fileUploaded.Name,
                            type: fileUploaded.Extension,
                        };
                        var url = fileUploaded.FullName;
                        this.$refs.myVueDropzone.manuallyAddFile(file, url);
                    });
                }
                this.FilesUploaded = true;
            }
        },
        UploadedToDropzone() {
            this.$set(this.ProdExpVendor, "CompletedForms", this.GetFilesObject());
        },
        RemovedFromDropzone() {
            this.$set(this.ProdExpVendor, "CompletedForms", this.GetFilesObject());
        },
        GetFilesObject() {
            let files = [];
            if (this.$refs.myVueDropzone.dropzone.files && this.$refs.myVueDropzone.dropzone.files.length > 0) {
                let filesExists = this.$refs.myVueDropzone.dropzone.files;
                for (let i = 0; i < filesExists.length; i++) {
                    files.push({
                        name: filesExists[i].name,
                        file: filesExists[i]
                    });
                }
                return files;
            } else {
                return files;
            }
        },
        async downloadUploadTemplate() {
            let file = {
                Category: "ProductionExpense"
            };
            this.$store
                .dispatch("vendorValidation/DownloadExternalTemplate", file)
                .then((response) => {
                    const blob = new Blob([response.data], {
                        type: file.Extension
                    });
                    const link = document.createElement("a");
                    link.href = URL.createObjectURL(blob);
                    link.download = "External Form - Production-Expense Vendor.pdf";
                    link.click();
                    URL.revokeObjectURL(link.href);
                })
                .catch((ex) => {
                    if (ex.response) {
                        this.$store.dispatch(
                            "progress/setErrorMessage",
                            `Error while downloading file. ${ex.response.data}`
                        );
                    } else {
                        this.$store.dispatch(
                            "progress/setErrorMessage",
                            `Error while downloading file. ${ex}`
                        );
                    }
                });
        },
        Cancel() {
            this.$router.push("/VendorRequests");
        },
        Next() {
            this.$parent.$emit("stepChanged", this.$route.meta.tabIndex);
            if (this.id) {
                this.$router.push({
                    name: "Production Expense Vendor Setup Info",
                    params: {
                        id: this.id,
                        isDraft: this.isDraft
                    }
                });
            } else {
                this.$router.push({
                    name: "Production Expense Vendor Setup Info",
                });
            }
        },
        Previous() {
            if (this.id) {
                this.$router.push({
                    name: "Production Expense Vendor Employee Info",
                    params: {
                        id: this.id,
                        isDraft: this.isDraft
                    }
                });
            } else {
                this.$router.push({
                    name: "Production Expense Vendor Employee Info"
                });
            }
        },
        template: function () {
            return `<div class="dz-preview dz-file-preview" style='background-color:#ffffff !important;display:flex;'>

                <div class="dz-details" style='margin-right:79px !important;'>
                    <div class="dz-size" style="display:none;" ><span data-dz-size></span></div>
                    <div class="FileforNewClientxls-Copy" style="margin-left:20px;width:280px;cursor:default !important;" ><span style='word-break:break-all !important;font-size:14px !important;font-weight:400;font-stretch:normal;font-style: normal;line-height: 0.71;color: #00a1d2 !important; font-family:"Open Sans" !important;' data-dz-name></span></div>
                </div>
                <a>
                 <img data-dz-remove=""  style='' src='/icons/fileremove.svg'  @click="DeleteServerFile()" ></img>
                </a>
            </div>`;
        },

    }
}
</script>